import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ResultsService } from '../../../core/services/results.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  lang = 'en';

  public contactUs = {
    firstname: null,
    lastname: null,
    email: null,
    telephone: null,
    messagebody: null,
  };
  public isClicked = false;

  swal: any = Swal;

  constructor(private titleService: Title, private resultsService: ResultsService) { }

  ngOnInit() {

    this.titleService.setTitle('Contact Us' + ' ' + '|' + ' ' + 'Vervendo.com');
    this.hideHeader();
    this.hideBookInfo();
    this.hideVillaName();
  }

  showText() {
    const x = document.getElementById('sentText');
    x.style.display = 'block';


  }

  windowChange() {

    const w = window.innerWidth;
    if (w === 576) {

      return true;
    }

    return false;
  }


  hideHeader() {

    const x = document.getElementById('headerSorting');

    if (x) {

      x.style.display = 'none';
    }
  }

  hideBookInfo() {
    const w = document.getElementById('bookInfo');
    if (w) {
      w.style.visibility = 'hidden';
    }
  }

  hideVillaName() {
    const r = document.getElementById('headerSortig');
    if (r) {
      r.style.visibility = 'hidden';
    }
  }
  sendContactUs() {
    if (this.contactUs.email === null || this.contactUs.email.length === 0
      || this.contactUs.firstname === null || this.contactUs.firstname.length === 0 ||
      this.contactUs.lastname === null || this.contactUs.lastname.length === 0 || this.contactUs.messagebody === null
      || this.contactUs.messagebody.length === 0) {
      this.swal.fire({
        icon: 'error',
        title: 'Some fields are empty!',
        text: 'Please fill the required fields and try again'
      });
      return;
    }
    this.resultsService.sendContactUs(this.contactUs).subscribe((data: any) => {
      this.swal.fire({
        icon: 'success',
        title: 'Thank you!',
        text: 'Your message has been sent. We will get in touch shortly'
      });
      /*const x = document.getElementById('sentText');
      x.style.visibility = 'visible';*/
      this.isClicked = true;
      this.contactUs.telephone = null;
      this.contactUs.lastname = null;
      this.contactUs.firstname = null;
      this.contactUs.email = null;
      setTimeout(() => {
        this.isClicked = false;
      }, 6000);
    },
      (error) => console.log(error));
  }
}





